import React from "react";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./smartFilterLoader.module.scss";

/**
 * Custom loader for Smart Filter button — 4 white dots with bouncing wave animation
 */
const SmartFilterLoader: React.FC = () => (
  <div className={styles.loader}>
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
  </div>
);

export default wrapperHOC(SmartFilterLoader, {
  componentName: "SmartFilterLoader-SearchPage",
  showForChina: true,
});
